import { Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { Control, FieldValues } from "react-hook-form";
import { FinancialRowConfig } from "../../types";
import { PriceRowLayout } from "./PriceRowLayout";
import { PriceField } from "./PriceField";

type Props<TFieldValues extends FieldValues> = Readonly<{
  row: FinancialRowConfig;
  value: string | number;
  usd: string;
  editable: boolean;
  control?: Control<TFieldValues>;
  inputSx?: SxProps<Theme>;
  currency?: string;
}>;

export function FinancialRow<TFieldValues extends FieldValues>({
  row,
  value,
  usd,
  editable,
  control,
  inputSx,
  currency,
}: Props<TFieldValues>) {
  const computedVariant = row.variant ?? "positive";

  return (
    <PriceRowLayout label={row.label} variant={computedVariant}>
      {editable && control ? (
        <PriceField
          control={control}
          name={row.key}
          inputSx={inputSx}
          currency={currency}
          editable={true}
        />
      ) : (
        <PriceField value={value} currency={currency} editable={false} />
      )}

      <Typography variant="caption" color="text.secondary" textAlign="right">
        {usd} $
      </Typography>
    </PriceRowLayout>
  );
}
